import { createStore } from 'effector'
import { GetMyRes } from '../../services/api/My'
import { getMyFx } from './event'

export const $my = createStore<GetMyRes | null>(null)
  .on(getMyFx.done, (_, { result }) => result.data.data)
